var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    clipPath: "url(#clip0_16_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.7876 2.95935H20.2126V18.7032C20.2126 20.9432 18.3966 22.7594 16.1563 22.7594H1.7876V2.95935ZM3.0251 4.19685V21.5219H16.1563C17.7131 21.5219 18.9751 20.2598 18.9751 18.7032V4.19685H3.0251Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    className: "highlight",
    d: "M10.9999 9.89355L12.3608 12.2752L15.0466 12.8337L13.202 14.8641L13.5008 17.5908L10.9998 16.4639L8.49885 17.5909L8.79773 14.8641L6.95312 12.8337L9.63887 12.2752L10.9999 9.89355ZM10.9998 12.3878L10.4367 13.3733L9.32528 13.6044L10.0886 14.4446L9.96495 15.5729L10.9999 15.1066L12.0348 15.5729L11.9111 14.4446L12.6744 13.6044L11.563 13.3733L10.9998 12.3878Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    className: "highlight",
    d: "M5.2251 3.57812V1H6.4626V3.57812H5.2251Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    className: "highlight",
    d: "M10.3813 3.57812V1H11.6188V3.57812H10.3813Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    className: "highlight",
    d: "M15.5376 3.57812V1H16.7751V3.57812H15.5376Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.40625 6.39685H19.5938V7.63435H2.40625V6.39685Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2125 16.9844C20.2125 18.2754 19.1659 19.322 17.875 19.322H16.775V20.4219C16.775 21.7129 15.7284 22.7595 14.4375 22.7595V21.522C15.0449 21.522 15.5375 21.0295 15.5375 20.4219V18.0845H17.875C18.4824 18.0845 18.975 17.592 18.975 16.9844H20.2125Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_16_2",
    x: 2.95312,
    y: 9.89355,
    width: 16.0933,
    height: 15.6973,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.7e80c8c56b79669068b391e4bdc945c8.svg";
export { ForwardRef as ReactComponent };